export const data = {
	items: [
		{
			id: 1,
			name: "item1",
			bool: false,
			image: "https://picsum.photos/600/600",
			nested: {
				name: "nested1"
			}
		},
		{
			id: 2,
			name: "item2",
			bool: false,
			image: "https://picsum.photos/600/600",
			nested: {
				name: "nested2"
			}
		},
		{
			id: 3,
			name: "item3",
			bool: false,
			image: "https://picsum.photos/600/600",
			nested: {
				name: "nested3"
			}
		},
		{
			id: 4,
			name: "item4",
			bool: false,
			image: "https://picsum.photos/600/600",
			nested: {
				name: "nested4"
			}
		},
		{
			id: 5,
			name: "item5",
			bool: false,
			image: "https://picsum.photos/600/600",
			nested: {
				name: "nested5"
			}
		},
		{
			id: 6,
			name: "item6",
			bool: false,
			image: "https://picsum.photos/600/600",
			nested: {
				name: "nested6"
			}
		}
	],

	item: {
		id: 1,
		name: "item1",
		bool: false
	}
};
